$('.btn-show-all-portfolio').click(function () {
	$(this).closest('.photos-area').find('.col-photo').removeClass('d-none');
	$(this).hide();
	return false;
});